/* eslint-disable spellcheck/spell-checker */

import { CountryCallingCode, CountryCode } from 'libphonenumber-js'

export type Country = {
  countryCode: CountryCode
  dialingCode: CountryCallingCode
  name: string
}

// This output is the result of doing:

// import { getCountries, getCountryCallingCode } from 'libphonenumber-js'
// const regionNames = new Intl.DisplayNames(['en'], { type: 'region' })
//
// const countryArray: Country[] = getCountries().map((countryCode) => ({
//   countryCode,
//   dialingCode: getCountryCallingCode(countryCode),
//   name: regionNames.of(countryCode) || '',
// }))

// Intl.DisplayNames is not supported in old brosers
// this solution is simpler than implementing polyfills

export const countryArray: Country[] = [
  { countryCode: 'AC', dialingCode: '247', name: 'Ascension Island' },
  { countryCode: 'AD', dialingCode: '376', name: 'Andorra' },
  { countryCode: 'AE', dialingCode: '971', name: 'United Arab Emirates' },
  { countryCode: 'AF', dialingCode: '93', name: 'Afghanistan' },
  { countryCode: 'AG', dialingCode: '1', name: 'Antigua & Barbuda' },
  { countryCode: 'AI', dialingCode: '1', name: 'Anguilla' },
  { countryCode: 'AL', dialingCode: '355', name: 'Albania' },
  { countryCode: 'AM', dialingCode: '374', name: 'Armenia' },
  { countryCode: 'AO', dialingCode: '244', name: 'Angola' },
  { countryCode: 'AR', dialingCode: '54', name: 'Argentina' },
  { countryCode: 'AS', dialingCode: '1', name: 'American Samoa' },
  { countryCode: 'AT', dialingCode: '43', name: 'Austria' },
  { countryCode: 'AU', dialingCode: '61', name: 'Australia' },
  { countryCode: 'AW', dialingCode: '297', name: 'Aruba' },
  { countryCode: 'AX', dialingCode: '358', name: 'Åland Islands' },
  { countryCode: 'AZ', dialingCode: '994', name: 'Azerbaijan' },
  { countryCode: 'BA', dialingCode: '387', name: 'Bosnia & Herzegovina' },
  { countryCode: 'BB', dialingCode: '1', name: 'Barbados' },
  { countryCode: 'BD', dialingCode: '880', name: 'Bangladesh' },
  { countryCode: 'BE', dialingCode: '32', name: 'Belgium' },
  { countryCode: 'BF', dialingCode: '226', name: 'Burkina Faso' },
  { countryCode: 'BG', dialingCode: '359', name: 'Bulgaria' },
  { countryCode: 'BH', dialingCode: '973', name: 'Bahrain' },
  { countryCode: 'BI', dialingCode: '257', name: 'Burundi' },
  { countryCode: 'BJ', dialingCode: '229', name: 'Benin' },
  { countryCode: 'BL', dialingCode: '590', name: 'St. Barthélemy' },
  { countryCode: 'BM', dialingCode: '1', name: 'Bermuda' },
  { countryCode: 'BN', dialingCode: '673', name: 'Brunei' },
  { countryCode: 'BO', dialingCode: '591', name: 'Bolivia' },
  { countryCode: 'BQ', dialingCode: '599', name: 'Caribbean Netherlands' },
  { countryCode: 'BR', dialingCode: '55', name: 'Brazil' },
  { countryCode: 'BS', dialingCode: '1', name: 'Bahamas' },
  { countryCode: 'BT', dialingCode: '975', name: 'Bhutan' },
  { countryCode: 'BW', dialingCode: '267', name: 'Botswana' },
  { countryCode: 'BY', dialingCode: '375', name: 'Belarus' },
  { countryCode: 'BZ', dialingCode: '501', name: 'Belize' },
  { countryCode: 'CA', dialingCode: '1', name: 'Canada' },
  { countryCode: 'CC', dialingCode: '61', name: 'Cocos (Keeling) Islands' },
  { countryCode: 'CD', dialingCode: '243', name: 'Congo - Kinshasa' },
  { countryCode: 'CF', dialingCode: '236', name: 'Central African Republic' },
  { countryCode: 'CG', dialingCode: '242', name: 'Congo - Brazzaville' },
  { countryCode: 'CH', dialingCode: '41', name: 'Switzerland' },
  { countryCode: 'CI', dialingCode: '225', name: 'Côte d’Ivoire' },
  { countryCode: 'CK', dialingCode: '682', name: 'Cook Islands' },
  { countryCode: 'CL', dialingCode: '56', name: 'Chile' },
  { countryCode: 'CM', dialingCode: '237', name: 'Cameroon' },
  { countryCode: 'CN', dialingCode: '86', name: 'China' },
  { countryCode: 'CO', dialingCode: '57', name: 'Colombia' },
  { countryCode: 'CR', dialingCode: '506', name: 'Costa Rica' },
  { countryCode: 'CU', dialingCode: '53', name: 'Cuba' },
  { countryCode: 'CV', dialingCode: '238', name: 'Cape Verde' },
  { countryCode: 'CW', dialingCode: '599', name: 'Curaçao' },
  { countryCode: 'CX', dialingCode: '61', name: 'Christmas Island' },
  { countryCode: 'CY', dialingCode: '357', name: 'Cyprus' },
  { countryCode: 'CZ', dialingCode: '420', name: 'Czechia' },
  { countryCode: 'DE', dialingCode: '49', name: 'Germany' },
  { countryCode: 'DJ', dialingCode: '253', name: 'Djibouti' },
  { countryCode: 'DK', dialingCode: '45', name: 'Denmark' },
  { countryCode: 'DM', dialingCode: '1', name: 'Dominica' },
  { countryCode: 'DO', dialingCode: '1', name: 'Dominican Republic' },
  { countryCode: 'DZ', dialingCode: '213', name: 'Algeria' },
  { countryCode: 'EC', dialingCode: '593', name: 'Ecuador' },
  { countryCode: 'EE', dialingCode: '372', name: 'Estonia' },
  { countryCode: 'EG', dialingCode: '20', name: 'Egypt' },
  { countryCode: 'EH', dialingCode: '212', name: 'Western Sahara' },
  { countryCode: 'ER', dialingCode: '291', name: 'Eritrea' },
  { countryCode: 'ES', dialingCode: '34', name: 'Spain' },
  { countryCode: 'ET', dialingCode: '251', name: 'Ethiopia' },
  { countryCode: 'FI', dialingCode: '358', name: 'Finland' },
  { countryCode: 'FJ', dialingCode: '679', name: 'Fiji' },
  {
    countryCode: 'FK',
    dialingCode: '500',
    name: 'Falkland Islands (Islas Malvinas)',
  },
  { countryCode: 'FM', dialingCode: '691', name: 'Micronesia' },
  { countryCode: 'FO', dialingCode: '298', name: 'Faroe Islands' },
  { countryCode: 'FR', dialingCode: '33', name: 'France' },
  { countryCode: 'GA', dialingCode: '241', name: 'Gabon' },
  { countryCode: 'GB', dialingCode: '44', name: 'United Kingdom' },
  { countryCode: 'GD', dialingCode: '1', name: 'Grenada' },
  { countryCode: 'GE', dialingCode: '995', name: 'Georgia' },
  { countryCode: 'GF', dialingCode: '594', name: 'French Guiana' },
  { countryCode: 'GG', dialingCode: '44', name: 'Guernsey' },
  { countryCode: 'GH', dialingCode: '233', name: 'Ghana' },
  { countryCode: 'GI', dialingCode: '350', name: 'Gibraltar' },
  { countryCode: 'GL', dialingCode: '299', name: 'Greenland' },
  { countryCode: 'GM', dialingCode: '220', name: 'Gambia' },
  { countryCode: 'GN', dialingCode: '224', name: 'Guinea' },
  { countryCode: 'GP', dialingCode: '590', name: 'Guadeloupe' },
  { countryCode: 'GQ', dialingCode: '240', name: 'Equatorial Guinea' },
  { countryCode: 'GR', dialingCode: '30', name: 'Greece' },
  { countryCode: 'GT', dialingCode: '502', name: 'Guatemala' },
  { countryCode: 'GU', dialingCode: '1', name: 'Guam' },
  { countryCode: 'GW', dialingCode: '245', name: 'Guinea-Bissau' },
  { countryCode: 'GY', dialingCode: '592', name: 'Guyana' },
  { countryCode: 'HK', dialingCode: '852', name: 'Hong Kong' },
  { countryCode: 'HN', dialingCode: '504', name: 'Honduras' },
  { countryCode: 'HR', dialingCode: '385', name: 'Croatia' },
  { countryCode: 'HT', dialingCode: '509', name: 'Haiti' },
  { countryCode: 'HU', dialingCode: '36', name: 'Hungary' },
  { countryCode: 'ID', dialingCode: '62', name: 'Indonesia' },
  { countryCode: 'IE', dialingCode: '353', name: 'Ireland' },
  { countryCode: 'IL', dialingCode: '972', name: 'Israel' },
  { countryCode: 'IM', dialingCode: '44', name: 'Isle of Man' },
  { countryCode: 'IN', dialingCode: '91', name: 'India' },
  {
    countryCode: 'IO',
    dialingCode: '246',
    name: 'British Indian Ocean Territory',
  },
  { countryCode: 'IQ', dialingCode: '964', name: 'Iraq' },
  { countryCode: 'IR', dialingCode: '98', name: 'Iran' },
  { countryCode: 'IS', dialingCode: '354', name: 'Iceland' },
  { countryCode: 'IT', dialingCode: '39', name: 'Italy' },
  { countryCode: 'JE', dialingCode: '44', name: 'Jersey' },
  { countryCode: 'JM', dialingCode: '1', name: 'Jamaica' },
  { countryCode: 'JO', dialingCode: '962', name: 'Jordan' },
  { countryCode: 'JP', dialingCode: '81', name: 'Japan' },
  { countryCode: 'KE', dialingCode: '254', name: 'Kenya' },
  { countryCode: 'KG', dialingCode: '996', name: 'Kyrgyzstan' },
  { countryCode: 'KH', dialingCode: '855', name: 'Cambodia' },
  { countryCode: 'KI', dialingCode: '686', name: 'Kiribati' },
  { countryCode: 'KM', dialingCode: '269', name: 'Comoros' },
  { countryCode: 'KN', dialingCode: '1', name: 'St. Kitts & Nevis' },
  { countryCode: 'KP', dialingCode: '850', name: 'North Korea' },
  { countryCode: 'KR', dialingCode: '82', name: 'South Korea' },
  { countryCode: 'KW', dialingCode: '965', name: 'Kuwait' },
  { countryCode: 'KY', dialingCode: '1', name: 'Cayman Islands' },
  { countryCode: 'KZ', dialingCode: '7', name: 'Kazakhstan' },
  { countryCode: 'LA', dialingCode: '856', name: 'Laos' },
  { countryCode: 'LB', dialingCode: '961', name: 'Lebanon' },
  { countryCode: 'LC', dialingCode: '1', name: 'St. Lucia' },
  { countryCode: 'LI', dialingCode: '423', name: 'Liechtenstein' },
  { countryCode: 'LK', dialingCode: '94', name: 'Sri Lanka' },
  { countryCode: 'LR', dialingCode: '231', name: 'Liberia' },
  { countryCode: 'LS', dialingCode: '266', name: 'Lesotho' },
  { countryCode: 'LT', dialingCode: '370', name: 'Lithuania' },
  { countryCode: 'LU', dialingCode: '352', name: 'Luxembourg' },
  { countryCode: 'LV', dialingCode: '371', name: 'Latvia' },
  { countryCode: 'LY', dialingCode: '218', name: 'Libya' },
  { countryCode: 'MA', dialingCode: '212', name: 'Morocco' },
  { countryCode: 'MC', dialingCode: '377', name: 'Monaco' },
  { countryCode: 'MD', dialingCode: '373', name: 'Moldova' },
  { countryCode: 'ME', dialingCode: '382', name: 'Montenegro' },
  { countryCode: 'MF', dialingCode: '590', name: 'St. Martin' },
  { countryCode: 'MG', dialingCode: '261', name: 'Madagascar' },
  { countryCode: 'MH', dialingCode: '692', name: 'Marshall Islands' },
  { countryCode: 'MK', dialingCode: '389', name: 'North Macedonia' },
  { countryCode: 'ML', dialingCode: '223', name: 'Mali' },
  { countryCode: 'MM', dialingCode: '95', name: 'Myanmar (Burma)' },
  { countryCode: 'MN', dialingCode: '976', name: 'Mongolia' },
  { countryCode: 'MO', dialingCode: '853', name: 'Macao' },
  { countryCode: 'MP', dialingCode: '1', name: 'Northern Mariana Islands' },
  { countryCode: 'MQ', dialingCode: '596', name: 'Martinique' },
  { countryCode: 'MR', dialingCode: '222', name: 'Mauritania' },
  { countryCode: 'MS', dialingCode: '1', name: 'Montserrat' },
  { countryCode: 'MT', dialingCode: '356', name: 'Malta' },
  { countryCode: 'MU', dialingCode: '230', name: 'Mauritius' },
  { countryCode: 'MV', dialingCode: '960', name: 'Maldives' },
  { countryCode: 'MW', dialingCode: '265', name: 'Malawi' },
  { countryCode: 'MX', dialingCode: '52', name: 'Mexico' },
  { countryCode: 'MY', dialingCode: '60', name: 'Malaysia' },
  { countryCode: 'MZ', dialingCode: '258', name: 'Mozambique' },
  { countryCode: 'NA', dialingCode: '264', name: 'Namibia' },
  { countryCode: 'NC', dialingCode: '687', name: 'New Caledonia' },
  { countryCode: 'NE', dialingCode: '227', name: 'Niger' },
  { countryCode: 'NF', dialingCode: '672', name: 'Norfolk Island' },
  { countryCode: 'NG', dialingCode: '234', name: 'Nigeria' },
  { countryCode: 'NI', dialingCode: '505', name: 'Nicaragua' },
  { countryCode: 'NL', dialingCode: '31', name: 'Netherlands' },
  { countryCode: 'NO', dialingCode: '47', name: 'Norway' },
  { countryCode: 'NP', dialingCode: '977', name: 'Nepal' },
  { countryCode: 'NR', dialingCode: '674', name: 'Nauru' },
  { countryCode: 'NU', dialingCode: '683', name: 'Niue' },
  { countryCode: 'NZ', dialingCode: '64', name: 'New Zealand' },
  { countryCode: 'OM', dialingCode: '968', name: 'Oman' },
  { countryCode: 'PA', dialingCode: '507', name: 'Panama' },
  { countryCode: 'PE', dialingCode: '51', name: 'Peru' },
  { countryCode: 'PF', dialingCode: '689', name: 'French Polynesia' },
  { countryCode: 'PG', dialingCode: '675', name: 'Papua New Guinea' },
  { countryCode: 'PH', dialingCode: '63', name: 'Philippines' },
  { countryCode: 'PK', dialingCode: '92', name: 'Pakistan' },
  { countryCode: 'PL', dialingCode: '48', name: 'Poland' },
  { countryCode: 'PM', dialingCode: '508', name: 'St. Pierre & Miquelon' },
  { countryCode: 'PR', dialingCode: '1', name: 'Puerto Rico' },
  { countryCode: 'PS', dialingCode: '970', name: 'Palestine' },
  { countryCode: 'PT', dialingCode: '351', name: 'Portugal' },
  { countryCode: 'PW', dialingCode: '680', name: 'Palau' },
  { countryCode: 'PY', dialingCode: '595', name: 'Paraguay' },
  { countryCode: 'QA', dialingCode: '974', name: 'Qatar' },
  { countryCode: 'RE', dialingCode: '262', name: 'Réunion' },
  { countryCode: 'RO', dialingCode: '40', name: 'Romania' },
  { countryCode: 'RS', dialingCode: '381', name: 'Serbia' },
  { countryCode: 'RU', dialingCode: '7', name: 'Russia' },
  { countryCode: 'RW', dialingCode: '250', name: 'Rwanda' },
  { countryCode: 'SA', dialingCode: '966', name: 'Saudi Arabia' },
  { countryCode: 'SB', dialingCode: '677', name: 'Solomon Islands' },
  { countryCode: 'SC', dialingCode: '248', name: 'Seychelles' },
  { countryCode: 'SD', dialingCode: '249', name: 'Sudan' },
  { countryCode: 'SE', dialingCode: '46', name: 'Sweden' },
  { countryCode: 'SG', dialingCode: '65', name: 'Singapore' },
  { countryCode: 'SH', dialingCode: '290', name: 'St. Helena' },
  { countryCode: 'SI', dialingCode: '386', name: 'Slovenia' },
  { countryCode: 'SJ', dialingCode: '47', name: 'Svalbard & Jan Mayen' },
  { countryCode: 'SK', dialingCode: '421', name: 'Slovakia' },
  { countryCode: 'SL', dialingCode: '232', name: 'Sierra Leone' },
  { countryCode: 'SM', dialingCode: '378', name: 'San Marino' },
  { countryCode: 'SN', dialingCode: '221', name: 'Senegal' },
  { countryCode: 'SO', dialingCode: '252', name: 'Somalia' },
  { countryCode: 'SR', dialingCode: '597', name: 'Suriname' },
  { countryCode: 'SS', dialingCode: '211', name: 'South Sudan' },
  { countryCode: 'ST', dialingCode: '239', name: 'São Tomé & Príncipe' },
  { countryCode: 'SV', dialingCode: '503', name: 'El Salvador' },
  { countryCode: 'SX', dialingCode: '1', name: 'Sint Maarten' },
  { countryCode: 'SY', dialingCode: '963', name: 'Syria' },
  { countryCode: 'SZ', dialingCode: '268', name: 'Eswatini' },
  { countryCode: 'TA', dialingCode: '290', name: 'Tristan da Cunha' },
  { countryCode: 'TC', dialingCode: '1', name: 'Turks & Caicos Islands' },
  { countryCode: 'TD', dialingCode: '235', name: 'Chad' },
  { countryCode: 'TG', dialingCode: '228', name: 'Togo' },
  { countryCode: 'TH', dialingCode: '66', name: 'Thailand' },
  { countryCode: 'TJ', dialingCode: '992', name: 'Tajikistan' },
  { countryCode: 'TK', dialingCode: '690', name: 'Tokelau' },
  { countryCode: 'TL', dialingCode: '670', name: 'Timor-Leste' },
  { countryCode: 'TM', dialingCode: '993', name: 'Turkmenistan' },
  { countryCode: 'TN', dialingCode: '216', name: 'Tunisia' },
  { countryCode: 'TO', dialingCode: '676', name: 'Tonga' },
  { countryCode: 'TR', dialingCode: '90', name: 'Turkey' },
  { countryCode: 'TT', dialingCode: '1', name: 'Trinidad & Tobago' },
  { countryCode: 'TV', dialingCode: '688', name: 'Tuvalu' },
  { countryCode: 'TW', dialingCode: '886', name: 'Taiwan' },
  { countryCode: 'TZ', dialingCode: '255', name: 'Tanzania' },
  { countryCode: 'UA', dialingCode: '380', name: 'Ukraine' },
  { countryCode: 'UG', dialingCode: '256', name: 'Uganda' },
  { countryCode: 'US', dialingCode: '1', name: 'United States' },
  { countryCode: 'UY', dialingCode: '598', name: 'Uruguay' },
  { countryCode: 'UZ', dialingCode: '998', name: 'Uzbekistan' },
  { countryCode: 'VA', dialingCode: '39', name: 'Vatican City' },
  { countryCode: 'VC', dialingCode: '1', name: 'St. Vincent & Grenadines' },
  { countryCode: 'VE', dialingCode: '58', name: 'Venezuela' },
  { countryCode: 'VG', dialingCode: '1', name: 'British Virgin Islands' },
  { countryCode: 'VI', dialingCode: '1', name: 'U.S. Virgin Islands' },
  { countryCode: 'VN', dialingCode: '84', name: 'Vietnam' },
  { countryCode: 'VU', dialingCode: '678', name: 'Vanuatu' },
  { countryCode: 'WF', dialingCode: '681', name: 'Wallis & Futuna' },
  { countryCode: 'WS', dialingCode: '685', name: 'Samoa' },
  { countryCode: 'XK', dialingCode: '383', name: 'Kosovo' },
  { countryCode: 'YE', dialingCode: '967', name: 'Yemen' },
  { countryCode: 'YT', dialingCode: '262', name: 'Mayotte' },
  { countryCode: 'ZA', dialingCode: '27', name: 'South Africa' },
  { countryCode: 'ZM', dialingCode: '260', name: 'Zambia' },
  { countryCode: 'ZW', dialingCode: '263', name: 'Zimbabwe' },
]
